import {
  getBidDishNFTAddress,
  getBidBakerySoccerAddress,
  getBidOneInchBakeNFTAddress,
  getBidBakeryArtwork2NFTAddress,
  getBidBakeryArtwork3NFTAddress,
  getBidSeascapeNftAddress,
  getBidPetEggNFTAddress,
  getBidDigitalArtworkNFTAddress,
  getBidBinanceNftAddress,
  getBidWeaponNFTAddress,
  getBidBakeryArtworkNFTAddress,
  getBidPetNftAddress,
  getBidTokocryptoNFTAddress,
  getBidRacaNFTAddress
} from '../sushi/utils'


import { MARKETTYPE } from '../constants/bakery/nft'

export function userBidNFTAddress(sushi: any, type?: string) {
  let address = getBidDishNFTAddress(sushi)
  switch (type) {
    case MARKETTYPE.DISH:
      address = getBidDishNFTAddress(sushi)
      break
    case MARKETTYPE.BAKERYSOCCER:
      address = getBidBakerySoccerAddress(sushi)
      break
    case MARKETTYPE.ONEINCH:
      address = getBidOneInchBakeNFTAddress(sushi)
      break
    case MARKETTYPE.MUSKDOGE:
      address = getBidBakeryArtwork2NFTAddress(sushi)
      break
    case MARKETTYPE.MEME:
      address = getBidBakeryArtwork3NFTAddress(sushi)
      break
    case MARKETTYPE.SEASCAPE:
      address = getBidSeascapeNftAddress(sushi)
      break
    case MARKETTYPE.EGGNFT:
      address = getBidPetEggNFTAddress(sushi)
      break
    case MARKETTYPE.BTCARTWORK:
      address = getBidDigitalArtworkNFTAddress(sushi)
      break
    case MARKETTYPE.BINANCENFT:
      address = getBidBinanceNftAddress(sushi)
      break
    case MARKETTYPE.WEAPONNFT:
      address = getBidWeaponNFTAddress(sushi)
      break
    case MARKETTYPE.BAKERYARTWORK:
      address = getBidBakeryArtworkNFTAddress(sushi)
      break
    case MARKETTYPE.PETNFT:
      address = getBidPetNftAddress(sushi)
      break
    case MARKETTYPE.TKONFT:
      address = getBidTokocryptoNFTAddress(sushi)
      break
    case MARKETTYPE.RACANFT:
      address = getBidRacaNFTAddress(sushi)
      break
  }
  return address
}
